<div
	class="row gx-0 px-2 flex-nowrap input-wrapper align-items-center {{ inputWrapperStyleClass }}"
	[ngClass]="{
		'disabled': disabled,
		'hovered': isHovered,
		'focused': isFocused,
		'error': hasError
	}"
>
	<!-- Number Input -->
	<input
		type="number"
		class="col ps-1 bg-transparent {{ inputStyleClass }}"
		[attr.id]="id"
		[attr.title]="title"
		[attr.placeholder]="placeholder"
		[attr.tabindex]="tabindex"
		[readOnly]="readOnly || disabled"
		[(ngModel)]="numberStringValue"
		(focusin)="isFocused = true"
		(focusout)="isFocused =  false"
		(mouseenter)="isHovered = true"
		(mouseleave)="isHovered =  false"
		(ngModelChange)="onInputChange($event)"
	/>

	<!-- Actions -->
	<span
		*ngIf="!readOnly"
		class="col-auto my-auto align-items-center d-flex cursor-pointer input-actions fw-regular fs-xl"
	>

		<!-- Clear -->
		<i
			class="action-item ft-x"
			*ngIf="showClearButton"
			(click)="clearValue()"
		></i>

		<!-- Revert -->
		<i
			class="action-item icon-action-undo"
			*ngIf="showRevertButton"
			(click)="revertValue()"
		></i>

		<!-- Increase -->
		<i
			class="action-item p-0 ft-chevron-up"
			[ngClass]="{
				'disabled': maxNumber !== undefined && numberValue >= maxNumber
			}"
			(mousedown)="onSpinnerEvent(true, 'increase');"
			(mouseup)="onSpinnerEvent(false, 'increase');"
		></i>

		<!-- Decrease -->
		<i
			class="action-item p-0 ft-chevron-down"
			[ngClass]="{
				'disabled': minNumber !== undefined && numberValue <= minNumber
			}"
			(mousedown)="onSpinnerEvent(true, 'decrease')"
			(mouseup)="onSpinnerEvent(false, 'decrease')"
		></i>
	</span>
</div>
